import React from 'react';
import ConfirmationField from '../ConfirmationField';

import i18n from 'utils/translate';
import { anonymise } from 'utils/data';
import { isAustrianIBAN } from 'utils/common';

export default function PaymentConfirmation({ type, iban, bic, halfWidth = false, broadTitle = false }) {
  if (type === 'sepa') {
    const showBIC = !isAustrianIBAN(iban);

    return (
      <div>
        <ConfirmationField halfWidth={halfWidth} broadTitle={broadTitle} title={i18n('Zahlungsart')}>
          {i18n('SEPA-Lastschrift')}
        </ConfirmationField>
        <ConfirmationField halfWidth={halfWidth} broadTitle={broadTitle} title={i18n('IBAN')}>
          {anonymise(iban, 2, 4)}
        </ConfirmationField>
        {showBIC && bic && (
          <ConfirmationField halfWidth={halfWidth} broadTitle={broadTitle} title={i18n('BIC')}>
            {bic}
          </ConfirmationField>
        )}
      </div>
    );
  } else if (type === 'erlagschein') {
    return (
      <div>
        <ConfirmationField halfWidth={halfWidth} broadTitle={broadTitle} title={i18n('Zahlungsart')}>
          {i18n('Erlagschein')}
        </ConfirmationField>
      </div>
    );
  } else {
    return (
      <div>
        <ConfirmationField halfWidth={halfWidth} broadTitle={broadTitle} title={i18n('Zahlungsart')}>
          {i18n('Kreditkarte')}
        </ConfirmationField>
      </div>
    );
  }
}
